export default __webpack_public_path__ + "static/media/Belt of the Unholy Communion.a6f8b021.jpg";